import { render, staticRenderFns } from "./LoanTags.vue?vue&type=template&id=334d62c9"
import script from "./LoanTags.vue?vue&type=script&lang=js"
export * from "./LoanTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports